export default __webpack_public_path__ + "static/media/sxmCoin.c68cc760.svg";